const BASE = process.env.REACT_APP_API_URL || '/api';

async function req(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export const api = {
  getBusiness:      ()     => req('GET',    '/business'),
  updateBusiness:   (data) => req('PUT',    '/business', data),
  getParties:       ()     => req('GET',    '/parties'),
  addParty:         (data) => req('POST',   '/parties', data),
  updateParty:      (id, data) => req('PUT', `/parties/${id}`, data),
  deleteParty:      (id)   => req('DELETE', `/parties/${id}`),
  getTransactions:  (pid)  => req('GET',    `/transactions${pid ? `?party_id=${pid}` : ''}`),
  addTransaction:   (data) => req('POST',   '/transactions', data),
  deleteTransaction:(id)   => req('DELETE', `/transactions/${id}`),
  getSummary:       ()     => req('GET',    '/summary'),
  getReport:        (s, e) => req('GET',    `/report?start=${s}&end=${e}`),
};
